import { render } from "./ManagerAddOrEdit.vue?vue&type=template&id=5e54fd00"
import script from "./ManagerAddOrEdit.vue?vue&type=script&lang=js"
export * from "./ManagerAddOrEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__